/**
 * Auth State Enums - Type-safe state management for authentication pages
 */

/**
 * Login page states
 */
export enum LoginState {
  Idle = 'idle',
  Loading = 'loading',
  Sent = 'sent',
  Error = 'error',
}

/**
 * Verification page states
 */
export enum VerifyState {
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
}
